export const isMonthlyHourlySwitch = (ogType, newType) => {
    if (ogType === 'monthly')
        return newType === 'hourly';
    else if (ogType === 'hourly')
        return newType === 'monthly';
    else
        return false;
};
